import React from 'react'
import { useTranslation } from 'react-i18next'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'

import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'

import ContextMenu from '../ContextMenu'
import Button from '../Button'

import CartContext from './CartContext'
import useStyles from './useStyles'

import type { CartContextValue, CartDescription } from './CartContext'
import { useHistory } from 'react-router'

const CartProvider: React.FunctionComponent = (props) => {
  const { children } = props
  const { t } = useTranslation()
  const history = useHistory()
  const classes = useStyles()

  const timmerRef = React.useRef<ReturnType<typeof window.setTimeout> | null>(null)

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  // const [width, setWidth] = React.useState(0)
  const [open, setOpen] = React.useState<boolean>(false)

  const [cartDescription, setCartDescription] = React.useState<Required<CartDescription> | null>(null)

  // 啟動計時器
  const setupTimmer = () => {
    timmerRef.current = setTimeout(() => setOpen(false), 3e3)
  }

  const context: CartContextValue = React.useMemo(
    () => ({
      setAnchorEl,
      updateCart(description: CartDescription) {
        timmerRef.current && clearTimeout(timmerRef.current)

        setCartDescription({
          productTotal: description.productTotal,
          productName: description.productName,
          productImage: description.productImage,
          productCount: description.productCount ?? null,
          productPatient: description.productPatient ?? null,
        })

        setOpen(true)
        setupTimmer()
      },
    }),
    [timmerRef],
  )

  const handleClose = () => {
    setOpen(false)
  }

  // React.useEffect(() => {
  //   setWidth(() => {
  //     if (!anchorEl) return 0
  //     return document.body.clientWidth - anchorEl.getBoundingClientRect().left - 16
  //   })
  // }, [anchorEl, open])

  React.useEffect(() => {
    if (!open) {
      setCartDescription(null)
      return
    }
    setupTimmer()
  }, [open])

  return (
    <CartContext.Provider value={context}>
      {children}
      <ContextMenu open={open} onClose={handleClose} anchorEl={anchorEl} offsetY={8}>
        <Card style={{ width: '350px' }}>
          {cartDescription ? (
            <>
              <CardHeader
                action={
                  <IconButton onClick={handleClose}>
                    <Clear />
                  </IconButton>
                }
                title={t('cart.alreadyAddedToShoppingCart')}
              />
              <CardContent>
                <div className={classes.productItem}>
                  <img className={classes.productImage} src={cartDescription.productImage} />
                  <div className={classes.productDescription}>
                    <h3>{cartDescription.productName}</h3>
                    {cartDescription.productCount && (
                      <div>
                        {t('cart.count')}：{cartDescription.productCount}
                      </div>
                    )}
                  </div>
                </div>
              </CardContent>
              <CardActions>
                <Button onClick={() => history.push('/pages/cart')} type='button'>
                  {t('cart.viewCart')} ({cartDescription.productTotal})
                </Button>
              </CardActions>
            </>
          ) : null}
        </Card>
      </ContextMenu>
    </CartContext.Provider>
  )
}

export default CartProvider
